import { FiveStarFieldProps } from 'components/inputs/FiveStarField';
import { Theme, css } from '@emotion/react';
import { assertNever } from '@tock/shared/utils/typeUtils';

export const ratingBase = ({ colors }: Theme) => css`
  .MuiRating-icon {
    color: ${colors.fgDefault};
  }
`;

export const ratingSize =
  (size: NonNullable<FiveStarFieldProps['size']>) =>
  ({ typography, spacing }: Theme) => {
    switch (size) {
      case 'small':
        return css`
          font-size: ${typography.pxToRem(28)};
        `;
      case 'medium':
        return css`
          font-size: ${typography.pxToRem(48)};
          /**
           * Any spacing between ratings needs to be applied so that it is included in the width calculation
           * of the rating.  (no gap or margin) Failure to do this results in unexpected hover behavior
           * https://github.com/mui/material-ui/blob/v4.x/packages/material-ui-lab/src/Rating/Rating.js#L206
           */
          .MuiRating-label {
            padding: 0 ${spacing(0.5)}px;
          }
        `;
      default:
        assertNever(size);
    }
  };
